export default __webpack_public_path__ + "static/media/dashboard.d20a55ff.svg";